import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "switch__main" };
const _hoisted_2 = ["name", "disabled", "required"];
const _hoisted_3 = { class: "switch__cover checkbox__cover" };
const _hoisted_4 = {
    key: 0,
    class: "switch__label checkbox__label"
};
import Sprite from "../components/Sprite.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Checkbox',
    props: /*@__PURE__*/ _mergeModels({
        disabled: Boolean,
        required: Boolean,
        label: { type: String, default: '' },
        name: String,
        modifier: { type: String, default: 'm' },
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props) {
        const value = _useModel(__props, "modelValue");
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["switch checkbox", `checkbox--${__props.modifier}`])
            }, [
                _createElementVNode("label", _hoisted_1, [
                    _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "switch__input",
                        name: __props.name,
                        disabled: __props.disabled,
                        required: __props.required,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((value).value = $event))
                    }, null, 8 /* PROPS */, _hoisted_2), [
                        [_vModelCheckbox, value.value]
                    ]),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    _createElementVNode("span", _hoisted_3, [
                        _createVNode(Sprite, { name: "check" })
                    ]),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    (__props.label?.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.label), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                ])
            ], 2 /* CLASS */));
        };
    }
});
